import React from 'react';

import Button from '@atlaskit/button';

import { useFeedbackDispatch } from '../Feedback.reducer';
import { useFeedbackVisibility } from '../FeedbackVisibilityProvider';
import {
  ActionsWrapperStyled,
  HeaderWrapperStyled,
  ScreenStyled,
} from './Screens.styled';

export default function ThankYouScreen(): JSX.Element {
  const dispatch = useFeedbackDispatch();
  const { hideShareFeedback } = useFeedbackVisibility();

  const handleButtonClick = () => {
    hideShareFeedback();
    dispatch({
      type: 'click-ok',
    });
  };

  return (
    <ScreenStyled>
      <HeaderWrapperStyled>
        <h5>Thanks!</h5>
        <div>Your feedback will help us improve the app.</div>
      </HeaderWrapperStyled>
      <ActionsWrapperStyled>
        <Button appearance='primary' onClick={handleButtonClick}>
          Ok
        </Button>
      </ActionsWrapperStyled>
    </ScreenStyled>
  );
}
